var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:['btn', {'__red': _vm.mode === 'red'}],domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":function($event){return _vm.$emit('clickDef')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }